import axios from 'axios';

const api = axios.create({ baseURL: '/api', withCredentials: true });

api.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401 && !window.location.pathname.startsWith('/login')) {
    localStorage.removeItem('user');
    window.location.href = '/login';
  }
  return Promise.reject(err);
});

export default api;
